// extracted by mini-css-extract-plugin
export default {"modalCustomClass":"Modal_modalCustomClass__LD0i+","headerBackground":"Modal_headerBackground__06P7-"};